import { useState, useEffect } from 'react';

/**
 * Hook to check if the current session is in mimic mode (admin viewing as another user).
 * Used for layout offset when the mimic bar is visible.
 */
export const useIsMimicking = () => {
  const [isMimicking, setIsMimicking] = useState(false);

  useEffect(() => {
    const checkMimicState = () => {
      const originalToken = localStorage.getItem('originalAdminToken');
      const mimickedUserData = localStorage.getItem('mimickedUser');
      setIsMimicking(!!originalToken && !!mimickedUserData);
    };

    checkMimicState();
    window.addEventListener('storage', checkMimicState);
    return () => window.removeEventListener('storage', checkMimicState);
  }, []);

  return isMimicking;
};
